import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import PublicLayout from "./layouts/PublicLayout";
import AppLoader from "./components/GeneralComponents/AppLoader";
import LandingContent from "./components/portal/LandingContent";

const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const ContactsPage = lazy(() => import("./pages/Contacts/ContactsPage"));
const LoginGate = lazy(() => import("./pages/Login/Login"));
const NotFound = lazy(() => import("./pages/NotFound"));

function RouteFallback() {
  return <AppLoader minHeight="40vh" size="medium" />;
}

export default function Router() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/contacts" element={<ContactsPage />} />
        </Route>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<LandingContent />} />
          <Route path="/login" element={<LoginGate />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
